import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

/* Modules */
import { MaterialModule } from '../modules/material.module';
import { CustomSplitPipe } from '../pipes/custom-split.pipe';
/* Pipes */
import { FirstUppercasePipe } from '../pipes/first-uppercase.pipe';
import { MapDistinctPipe } from '../pipes/map-distinct.pipe';
import { OrderByPipe } from '../pipes/orderby.pipe';
import { ReplacePipe } from '../pipes/replace.pipe';
import { StorageUnitPipe } from '../pipes/storage-unit.pipe';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
/* Components */
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { NavListComponent } from './navigation/nav-list/nav-list.component';
import { ProfileMenuComponent } from './navigation/profile-menu/profile-menu.component';

const PIPES = [FirstUppercasePipe, CustomSplitPipe, StorageUnitPipe, ReplacePipe, OrderByPipe, MapDistinctPipe];
const COMPONENTS = [FooterComponent, BreadcrumbComponent, ProfileMenuComponent, HeaderComponent, NavListComponent];
@NgModule({
  declarations: [...COMPONENTS, ...PIPES],
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule, ReactiveFormsModule],
  exports: [...COMPONENTS, ...PIPES],
  providers: [DatePipe]
})
export class SharedComponentModule {}
